<template>
  <div class="tipo">
    <div class="centro">
      <h1><span>Consulta por Tipo de Legislação Municipal</span></h1>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cardsLegislacao" />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="tiposFormatados"
        :generateUrl="generateUrl"
        titulo="Tipo de Legislação Municipal"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import LegislacaoMunicipalApi from "../../../services/LegislacaoMunicipalApi";
import Loading from "../../../components/Loading";
import ErroResultados from "../../../components/ErroResultados";
import PainelBuscaSimplificada from "../../../components/PainelBuscaSimplificada";
import BuscaSimplesCards from "../../../components/BuscaSimplesCards.vue"; // Import BuscaSimplesCards
import { mixinLegislacao } from "../../../mixins/mixinLegislacao";

import metaDados from "../../../helpers/metaDados";

export default {
  name: "PorTipoMunicipal",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  metaInfo() {
    return {
      title: "Pesquisa de Legislação Municipal por Tipo",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa a Legislação Municipal por Tipo de Legislação - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Página de acesso e pesquisa a toda legislação e atos normativos do Governo do Estado de Goiás.",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa a Legislação Municipal por Tipo de Legislação - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinLegislacao],
  data() {
    return {
      carregando: true,
      erro: false,
      tipos: [],
      filtro: {
        tipo_legislacao: [],
        ano: null,
      },
      enteFederativoId: null, // New property to store enteFederativoId
      cardsLegislacao: [ // Override cardsLegislacao
        {
          rota: { name: "LegislacaoPorEnteFederativoPorTipo", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Legislação",
          descricao: "Consulte a Legislação<br /> por <strong>tipo</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorCategoria", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-categoria2.png"),
          iconeClasse: "categoria-icon",
          titulo: "Categoria",
          descricao: "Consulte a Legislação<br /> por <strong>categoria</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorAutor", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-autor2.png"),
          iconeClasse: "autor-icon",
          titulo: "Autor",
          descricao: "Consulte a Legislação<br /> por <strong>autor</strong>",
        },
        {
          rota: { name: "LegislacaoPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte a Legislação<br /> por <strong>ano</strong>",
        },
      ],
    };
  },
  computed: {
    // Parte para formatar os números com separador milhar.
    tiposFormatados() {
      return this.tipos.map((tipo) => {
        return {
          ...tipo,
          quantidade: tipo.quantidade_total,
        };
      });
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
    BuscaSimplesCards, // Register BuscaSimplesCards
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();

    this.findEnteFederativoAndLoadTipos(); // New method to find ente and load tipos
  },
  methods: {
    findEnteFederativoAndLoadTipos: async function () {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);

        if (!enteFederativo) {
          this.erro = true;
          this.carregando = false;
          return;
        }
        this.enteFederativoId = enteFederativo.id;
        this.carregarTipos();
      } catch (err) {
        console.log("findEnteFederativoAndLoadTipos", err);
        this.erro = true;
        this.carregando = false;
      }
    },
    carregarTipos: async function () {
      try {
        if (this.legislacaoApi.cancelTokens.getTiposByEnteFederativo) {
          this.legislacaoApi.cancelTokens.getTiposByEnteFederativo.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.tipos = await this.legislacaoApi.getTiposByEnteFederativo(this.enteFederativoId); // Use enteFederativoId
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.tipo_legislacao.push(dados.id);
      this.filtro.ano = ano;

      this.$router.push({
        name: "LegislacaoPorEnteFederativoBySlug", // Use new route name
        params: { slug: this.slug }, // Use slug
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: 1,
        },
      });
    },
    formatNumber(number) {
      // Método para formatar os números com separador milhar.
      if (number) return number.toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
h1 span{
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #0e489f;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>
